/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatpresetinstagramsquare3Inputs */

const en_formatpresetinstagramsquare3 = /** @type {(inputs: Formatpresetinstagramsquare3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram Post`)
};

const de_formatpresetinstagramsquare3 = /** @type {(inputs: Formatpresetinstagramsquare3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram-Beitrag`)
};

/**
* | output |
* | --- |
* | "Instagram Post" |
*
* @param {Formatpresetinstagramsquare3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatpresetinstagramsquare3 = /** @type {((inputs?: Formatpresetinstagramsquare3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatpresetinstagramsquare3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatpresetinstagramsquare3(inputs)
	return de_formatpresetinstagramsquare3(inputs)
});
export { formatpresetinstagramsquare3 as "formatPresetInstagramSquare" }